import {PAISESINDICATIVO} from "../Recursos/indicativos";

export const obtenerNumeroWass = ({numero, pais}) => {

    if (!pais || !numero) return null;

    // const query = countryQuery.toString().trim().toLowerCase();

    // Buscar coincidencia por iso2, iso3, nameES o nameEN
    const country = PAISESINDICATIVO.find((c) =>
        c.nameES === pais
    );

    if (!country || !country.phoneCode) return null;

    const cleanPhoneCode = country.phoneCode.replace(/\D/g, '');
    let cleanPhoneNumber = numero.toString().replace(/\D/g, '');

    // CASO ESPECIAL ECUADOR (ISO: EC / PhoneCode: 593)
    if (country.iso2 === 'EC' || cleanPhoneCode === '593') {
        // Si el usuario ingresó el celular con el cero inicial (ej: "0991234567"), se remueve
        if (cleanPhoneNumber.startsWith('0')) {
            cleanPhoneNumber = cleanPhoneNumber.substring(1);
        }
    }

    return `${cleanPhoneCode}${cleanPhoneNumber}`;

}